import { buildTokenHash, ogApiGet } from "//dev.bark.co/cdn/shop/t/1229/assets/ordergroove.js?v=10848403420202116351788363479";

if (document.readyState !== 'loading') {
  setWisepopsCustomProperties();
} else {
  document.addEventListener('DOMContentLoaded', setWisepopsCustomProperties);
}

async function setWisepopsCustomProperties() {
  const ogSigDataDiv = document.querySelector(".og-sig-data");
  let customerId;
  if (ogSigDataDiv) {
    try {
      customerId = ogSigDataDiv.getAttribute('data-attr-customer-id');

      if (!customerId) {
        unsetWisepopsSubscriptionId();
        return;
      }

      const disabledSubscriptionIds = await fetchDisabledSubscriptions(customerId);

      if (disabledSubscriptionIds.length > 0  && typeof wisepops !== 'undefined') {
        wisepops('properties', { subscription_id: disabledSubscriptionIds[0] });
      } else {
        unsetWisepopsSubscriptionId();
      }
    } catch (error) {
      onError(error, { customerId });
      unsetWisepopsSubscriptionId();
    }
  } else {
    const error = new Error("ogSigDataDiv not found");
    onError(error);
    unsetWisepopsSubscriptionId();
  }
}

async function fetchDisabledSubscriptions(customerId) {
  const tokenHash = buildTokenHash();

  const subscriptionsUrl = `/subscriptions/?page_size=100&live=true&customer=${customerId}`;
  const subscriptionsResponse = await ogApiGet(subscriptionsUrl, tokenHash);
  const subscriptions = subscriptionsResponse.data.results;

  return parseDisabledSubscriptionIds(subscriptions);
}

function parseDisabledSubscriptionIds(subscriptions) {
  const disabledSubs = subscriptions.filter((sub) => {
    const { live, extra_data: subExtraData = {}, prepaid_subscription_context: prepaidContext } = sub
    const { commitment: commitmentData = {} } = subExtraData;
    const { committed_orders_remaining: ordersRemaining, committed, state: commitmentState } = commitmentData;
    const isPrepaid = !!(prepaidContext && prepaidContext?.renewal_behavior);

    return !isPrepaid && live && ordersRemaining > 0 && committed && commitmentState === 'disable_autorenewal';
  });
  const sortedDisabledSubs = sortSubscriptions(disabledSubs);

  return sortedDisabledSubs.map(sub => sub.public_id);
}

function sortSubscriptions(subscriptions) {
  return subscriptions.sort((sub1, sub2) => {
    const { extra_data: subExtraData1 = {} } = sub1;
    const { commitment: commitmentData1 = {} } = subExtraData1;
    const { committed_orders_remaining: ordersRemaining1 } = commitmentData1;

    const { extra_data: subExtraData2 = {} } = sub2;
    const { commitment: commitmentData2 = {} } = subExtraData2;
    const { committed_orders_remaining: ordersRemaining2 } = commitmentData2;

    return ordersRemaining1 - ordersRemaining2;
  });
}

function unsetWisepopsSubscriptionId() {
  if (typeof wisepops !== 'undefined') {
    wisepops('properties', { subscription_id: null });
  }
}

function onError(error) {
  console.error("Wisepops custom attributes error", error);
  newrelic.noticeError(error);
}
